import React, { FunctionComponent } from 'react';

import RichText from 'components/RichText/RichText';
import { ColorNames, validFontCategories } from 'utils/styles/theme';

import * as S from './Headline.styles';

export interface HeadlineProps {
  text: string;
  color?: ColorNames;
  size?: typeof validFontCategories[number];
}

const defaultProps: Partial<HeadlineProps> = {
  text: '',
  size: 'heading1',
};

const Headline: FunctionComponent<HeadlineProps> = ({
  text,
  size,
  color,
  ...rest
}) => {
  return (
    <S.Wrapper {...rest}>
      <S.Container textColor={color}>
        <RichText as="h2" size={size} richText={text} defaultFormatting />
      </S.Container>
    </S.Wrapper>
  );
};

Headline.defaultProps = defaultProps;

export default Headline;
